/**
 * @license
 * @copyright Copyright Motili Inc., 2026 All Rights Reserved
 */

import { styled } from 'styled-components';
import { Chip } from '@motili/ui';

export const StyledChip = styled(Chip)`
    font-size: 14px;
    font-weight: 400;
    height: 28px;
    padding: 0 8px;
`;

export const StatusChip = styled(StyledChip)<{ status?: string }>`
    
    ${({ status }) => {
        const s = (status || '').toUpperCase();
        if (s.includes('APPROVE'))
            return `border: 1px solid #15b039; color: #15b039; background: #edfaea;`;
        if (s.includes('REJECT'))
            return `border: 1px solid #E63232; color: #E63232; background:#FDF2F2;`;
        if (s.includes('ACCEPT'))
            return `border: 1px solid #cccccc; color: #333333; background: #ffffff;`;
        return `border: 1px solid #d9d9d9; color:#333; background:#fff;`;
    }}
`;
